export const webEmbedTab = {
  scope: {
    title: "¿Qué se busca en tu web?",
    only: "Solo",
    thisListing: "este anuncio",
    hint: "Recomendado si pegas el código en la página de este alojamiento. Desactívalo para que el buscador muestre todos tus alojamientos.",
  },
  where: {
    title: "¿Dónde quieres que aparezcan los alojamientos?",
    hint: "El buscador se ve igual en los tres casos. Lo que cambia es qué pasa cuando el visitante pulsa «Buscar».",
    ariaLabel: "Dónde aparece la disponibilidad",
    ownFields: {
      name: "Ya tengo mi propio buscador",
      hint: "No ponemos nuestra barra: usas tus campos y nos pasas la búsqueda",
    },
  },
  modes: {
    overlay: {
      name: "Flotando sobre tu web",
      tag: "Recomendado",
      desc: "La lista se abre en una ventana por encima de tu página, y se cierra con la X. Tu web no se mueve: el visitante vuelve exactamente donde estaba.",
    },
    inline: {
      name: "Dentro de tu página",
      desc: "La lista aparece en tu propia web, como una sección más: se puede desplazar con el resto del contenido y no hay nada que cerrar. Tú eliges en qué punto de la página sale.",
    },
    tab: {
      name: "En una pestaña nueva",
      desc: "La barra vive en tu web y, al buscar, la reserva continúa en otra pestaña. Es lo más simple, pero el visitante se lleva la reserva a otro sitio.",
    },
  },
  modeNote: {
    overlay: "El buscador ocupa un alto fijo y no cambia: la lista y todo el proceso de reserva ocurren en la ventana flotante, con su propio desplazamiento.",
    inline: "Aquí lo único que crece es la sección de la lista, que es justo lo que has pedido que crezca. El buscador sigue ocupando lo mismo y el calendario se abre por encima, sin descolocar nada.",
    tab: "Solo se incrusta la barra. Todo lo demás ocurre en el motor de reservas, en una pestaña aparte.",
  },
  webs: {
    bahia: "Web con portada",
    cala: "Web minimalista",
  },
  fondos: {
    white: "Blanco (por defecto)",
    transparent: "Transparente · adopta el de tu web",
  },
  appearance: {
    title: "Apariencia",
    buttonColor: "Color del botón",
    background: "Fondo del buscador",
    language: "Idioma",
  },
  preview: {
    title: "Así queda en una web",
    hint: "Una web de ejemplo con tu buscador puesto. Es el widget de verdad: elige fechas y pulsa Buscar para ver cómo se comporta.",
    openFull: "Abrir a tamaño real",
    testIn: "Probar en",
    testInAriaLabel: "Web de ejemplo",
    missingUuid: "Falta el identificador de la cuenta para generar el widget.",
    fakeUrl: "tu-web.com",
    iframeTitle: "Vista previa del widget en una web de ejemplo",
  },
  guide: {
    title: "Cómo ponerlo en tu web",
    hint: "Vale para cualquier página: HTML, WordPress (bloque «HTML personalizado»), Wix, Squarespace, Shopify… No hace falta instalar nada.",
    warn: "<b>Si tu web es Wix, Squarespace o Shopify</b>, dos cosas: en el <b>editor</b> el bloque de código siempre se ve vacío —solo funciona en «Vista previa» o publicado—, y como esas plataformas encierran el buscador en un recuadro suyo, <b>todo ocurre dentro de ese recuadro</b>: el calendario y la lista de alojamientos. Así que <b>estíralo hasta unos 900 px de alto</b> en el editor; si se queda corto, el calendario sale cortado. Del resto nos encargamos nosotros: no cambies el código.",
    missingUuid: "Falta el identificador de la cuenta para generar el código.",
    copy: "Copiar",
    copied: "Copiado",
    saveReload: "Guarda y recarga tu web",
  },
  steps: {
    script: {
      title: "Pega esto donde quieras que salga el buscador",
      titleOwn: "Pega esto una vez, en cualquier punto de la página",
      hint: "En el sitio exacto donde quieras la barra de fechas: la portada, una franja bajo el menú, una barra lateral…",
      hintOwn: "No pinta nada por sí solo: deja preparada la reserva para tu propio formulario.",
      after: "La barra ocupa un alto fijo y no cambia de tamaño, así que no te descuadra la página.",
    },
    target: {
      title: "Pega este hueco donde quieras que salga la lista",
      hint: "Lo normal es una sección propia debajo de la portada, con tu título encima («Disponibilidad», «Nuestras casas»…).",
      after: "Hasta que alguien busca, ese hueco no ocupa nada. Si no lo pones, la lista sale justo debajo del buscador.",
    },
    api: {
      title: "Conecta tus campos con el buscador",
      hint: "Tú te quedas con tu diseño, pero el calendario puede ser el nuestro: el que enseña el precio de cada noche, la estancia mínima y los días ocupados.",
      after: "Si prefieres tus propios campos de fecha, también vale: pásanos las fechas en formato AAAA-MM-DD directamente a WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "Copia manual",
    manualCopyDetail: "Tu navegador no permitió copiar automáticamente. El código ya está seleccionado.",
  },
};
